import { render, staticRenderFns } from "./Rating.vue?vue&type=template&id=f641ab88&scoped=true&"
import script from "./Rating.vue?vue&type=script&lang=js&"
export * from "./Rating.vue?vue&type=script&lang=js&"
import style0 from "./Rating.vue?vue&type=style&index=0&id=f641ab88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f641ab88",
  null
  
)

export default component.exports